module.exports = __webpack_public_path__ + "img/role_onestore.8635f88d.png";